"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parse = parse;

var _uiwidgetsCommon = require("uiwidgets-common");

var _DateParser = require("./DateParser");

var _DateParser2 = _interopRequireDefault(_DateParser);

var _DateParserFuzzy = require("./DateParserFuzzy");

var _DateParserFuzzy2 = _interopRequireDefault(_DateParserFuzzy);

var _DateParserRange = require("./DateParserRange");

var _DateParserRange2 = _interopRequireDefault(_DateParserRange);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var DEFAULT_PARSER = [_DateParserRange2.default, _DateParserFuzzy2.default, _DateParser2.default];

/**
 * Parse a date from the given string.
 *
 * @param s {String} the string to parse.
 * @param [opts] {Object} the options object.
 *   @param [opts.parsers] an array of parsers.
 * @return {Object} an object representing the date / period / range.
 */
function parse(s, opts) {
    var result = undefined;

    // if a string was provided, trim it and lowercase it for parsing.
    s && (s = s.trim().toLowerCase());

    opts || (opts = {});

    var parsers = [].concat(_toConsumableArray(opts.parsers || DEFAULT_PARSER));

    // iterate over parsers until we find a result or we run out of parsers.
    var parser = void 0;
    while ((0, _uiwidgetsCommon.isUndefined)(result) && (parser = parsers.shift())) {
        result = parser(s, opts);
    }

    return result;
};
//# sourceMappingURL=parse.js.map